import {
  USER_EDIT, USER_EDIT_FAILURE, USER_EDIT_SUCCESS,
  USER_DELETE, USER_DELETE_SUCCESS, USER_DELETE_FAILURE,
  USER_EDIT_SHOPS, USER_EDIT_SHOPS_FAILURE, USER_EDIT_SHOPS_SUCCESS,
  USER_EDIT_SHOPS_CLEAR,
  USER_UPDATE, USER_UPDATE_SUCCESS, USER_UPDATE_FAILURE,
  USER_AVARTAR_UPLOAD, USER_AVARTAR_UPLOAD_SUCCESS, USER_AVARTAR_UPLOAD_FAILURE,
  USEROVER_UPDATE, USEROVER_UPDATE_SUCCESS, USEROVER_UPDATE_FAILURE,
  USEROVER_CANCEL, USEROVER_CANCEL_SUCCESS, USEROVER_CANCEL_FAILURE
} from './mutation-types'
import constant from '../constant'

export default {
  state: {
    user: null,
    userTypes: null,
    shops: null,
    domains: null,
    businessTypes: null,
    joins: null,
    userNotify: null,
    uploadSuccess: false,
    uploadError: false,
    shopIds: []
  },
  getters: {
    userDetailEdit: state => {
      return state.user
    },
    userDetailshops: state => {
      return state.shops
    },
    userDetailUserTypes: state => {
      return state.userTypes
    },
    userDetailDomains: state => {
      return state.domains
    },
    userDetailBusinessTypes: state => {
      return state.businessTypes
    },
    userDetailJoins: state => {
      return state.joins
    },
    userDetailEditUserNotify: state => {
      return state.userNotify
    },
    imageUploadSuccess: state => {
      return state.uploadSuccess
    },
    imageUploadError: state => {
      return state.uploadError
    },
    shopIds: state => {
      return state.shopIds
    }
  },
  actions: {
    [USER_EDIT] ({dispatch, state, commit}, params) {
      var url = '/master/users/' + params.id + '/edit'
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(USER_EDIT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(USER_EDIT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [USER_EDIT_SHOPS] ({dispatch, state, commit}, params) {
      var data = {}
      var url = '/master/users/shops/' + params.data.departmentId
      dispatch('apiGet', {url: url, data: data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USER_EDIT_SHOPS_FAILURE, res.data)
            } else {
              commit(USER_EDIT_SHOPS_SUCCESS, { data: res.data })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USER_EDIT_SHOPS_CLEAR] ({dispatch, state, commit}, params) {
      state.shops = null
    },
    [USER_UPDATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/master/users/' + params.user_id, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USER_UPDATE_FAILURE, res.data)
            } else {
              commit(USER_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USEROVER_UPDATE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/master/users/over/' + params.user_id, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USEROVER_UPDATE_FAILURE, res.data)
            } else {
              commit(USEROVER_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USEROVER_CANCEL] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiPatch', {url: '/master/users/over_cancel/' + params.id, data: data, loadparams: 'block'})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USEROVER_CANCEL_FAILURE, res.data)
            } else {
              commit(USEROVER_CANCEL_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USER_DELETE] ({dispatch, state, commit}, params) {
      var data = {}
      if (params) {
        data = params.data
      }
      dispatch('apiDelete', {url: '/master/users/' + data})
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USER_DELETE_FAILURE, res.data)
            } else {
              commit(USER_DELETE_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          throw error
        })
    },
    [USER_AVARTAR_UPLOAD] ({dispatch, state, commit}, params) {
      state.uploadSuccess = false
      state.uploadError = false

      dispatch('apiPatch', { url: '/master/users/avatar', data: params.data, loadparams: false })
        .then(res => {
          if (res.status === 200 || res.status === 304) {
            if (res.data.error) {
              commit(USER_AVARTAR_UPLOAD_FAILURE, res.data)
            } else {
              commit(USER_AVARTAR_UPLOAD_SUCCESS, { data: res.data, callback: params.callback })
            }
          }
        })
        .catch(error => {
          state.uploadError = true
          throw error
        })
    }
  },
  mutations: {
    [USER_DELETE_FAILURE] (state, data) {
      console.log('USER_DELETE_FAILURE')
    },
    [USER_DELETE_SUCCESS] (state, data) {
      console.log('USER_DELETE_SUCCESS')
      data.callback()
    },
    [USER_EDIT_FAILURE] (state, data) {
      console.log('USER_EDIT_FAILURE')
    },
    [USER_EDIT_SUCCESS] (state, data) {
      console.log('USER_EDIT_SUCCESS')
      state.user = data.user.data[0]
      state.userTypes = data.user_types.data
      state.shops = data.shops.data
      state.domains = data.domains.data
      state.businessTypes = data.business_types.data
      state.joins = data.joins.data
      state.shopIds = data.shop_ids

      data.callback()
    },
    [USER_EDIT_SHOPS_FAILURE] (state, data) {
      console.log('USER_EDIT_SHOPS_FAILURE')
    },
    [USER_EDIT_SHOPS_SUCCESS] (state, data) {
      console.log('USER_EDIT_SHOPS_SUCCESS')
      state.shops = data.data.data
    },
    [USER_UPDATE_SUCCESS] (state, data) {
      console.log('USER_UPDATE_SUCCESS')
      data.callback()
    },
    [USER_UPDATE_FAILURE] (state, data) {
      console.log('USER_UPDATE_FAILURE')
      state.userNotify = {
        danger: true,
        errors: data.error.split(',')
      }
      setTimeout(() => {
        state.userNotify = null
      }, constant.notifyShowTime.long)
    },
    [USEROVER_UPDATE_SUCCESS] (state, data) {
      console.log('USEROVER_UPDATE_SUCCESS')
      data.callback()
    },
    [USEROVER_UPDATE_FAILURE] (state, data) {
      console.log('USEROVER_UPDATE_FAILURE')
      state.userNotify = {
        danger: true,
        errors: data.error.split(',')
      }
      setTimeout(() => {
        state.userNotify = null
      }, constant.notifyShowTime.long)
    },
    [USEROVER_CANCEL_SUCCESS] (state, data) {
      console.log('USEROVER_CANCEL_SUCCESS')
      data.callback()
    },
    [USEROVER_CANCEL_FAILURE] (state, data) {
      console.log('USEROVER_CANCEL_FAILURE')
    },
    [USER_AVARTAR_UPLOAD_SUCCESS] (state, data) {
      console.log('USER_AVARTAR_UPLOAD_SUCCESS')
      state.uploadSuccess = true
      data.callback(data.data)
    },
    [USER_AVARTAR_UPLOAD_FAILURE] (state, data) {
      console.log('USER_AVARTAR_UPLOAD_FAILURE')
      state.uploadError = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user-edit.js